export const getEnumValues = (def) => Object.keys(def)
    .map((key) => def[key])
    .filter((k) => !(parseInt(k, 10) >= 0));
export default getEnumValues;
